<template>
  <v-app-bar app dense height="64px" class="elevation-2 white" :class="{ blue: isXsScreen, 'darken-4': isXsScreen }">
    <v-app-bar-nav-icon dark class="d-flex d-sm-none" @click.stop="toggleDrawer"></v-app-bar-nav-icon>
    <v-toolbar-title class="pl-0">
      <v-icon v-if="isMinimized" @click="changeMinimize">mdi-chevron-double-right</v-icon>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <Notification v-if="isNotificationShown" />
      <Teacher v-if="role.name === 'Teacher'" />
      <User v-else />
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import User from '@/components/basic/menu/User'
import Teacher from '@/components/basic/menu/Teacher'
import Notification from '@/components/basic/menu/Notification'
export default {
  components: {
    Teacher,
    User,
    Notification
  },
  computed: {
    ...mapState('auth', ['role']),
    ...mapState('app', ['isMinimized']),
    ...mapState('constant', ['allowedNotiRoleTypes']),
    isXsScreen() {
      return this.$vuetify.breakpoint.xs
    },
    isNotificationShown() {
      return this.allowedNotiRoleTypes.includes(this.role.type)
    }
  },
  data() {
    return { drawer: true }
  },
  methods: {
    ...mapActions({
      changeMinimize: 'app/setMinimized'
    }),
    toggleDrawer: function() {
      this.drawer = !this.drawer
      this.$emit('toggle-drawer', this.drawer)
    }
  }
}
</script>

<style></style>
